<!-- Signed, coloured amount: "+1 234 zł" / "−56 zł". -->
<script lang="ts">
  import { fmtNum, signCls } from "../lib/format";
  let { v, d = 0 }: { v: number | null | undefined; d?: number } = $props();
</script>

{#if v === null || v === undefined || isNaN(v)}–{:else}<span class="money {signCls(v)}">{v > 0 ? "+" : v < 0 ? "−" : ""}{fmtNum(Math.abs(v), d)}&nbsp;zł</span>{/if}
